import { render, staticRenderFns } from "./EduDictText.vue?vue&type=template&id=12bff744"
import script from "./EduDictText.vue?vue&type=script&lang=js"
export * from "./EduDictText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports